Revolution.Module.extend({
    NAME: "mde.popins", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/main.js)

    initialize: function ($) {
        // appelé aussitôt la page chargée
        //console.log("module " + this.NAME);

        //_.bindAll(this, "closeNavMob", "showBtnExpendTouch");
        //

        //events
        $('.js-show-popin').magnificPopup();

        $('.popin-iframe').magnificPopup({
            delegate: '.js-show-popin-iframe',
            mainClass: 'mfp-fade',
            type: 'iframe'
        });

        $('.js-show-popin.-no-bg').on('mfpOpen', function (e /*, params */) {
            $('.mfp-bg').addClass('bg-transp');
        });
        $('.js-show-popin.-no-bg').on('mfpClose', function (e /*, params */) {
            $('.mfp-bg').removeClass('bg-transp');
        });

        $('body').on('click', '.js-close-popin', function () {
            $('.simple-popup-blocks-global').hide();
            $('body').css('overflow', 'auto');
        });

        $('body').on('click', '.spb_overlay', function () {
            $('.simple-popup-blocks-global').hide();
            $('body').css('overflow', 'auto');
        });


        $('body').magnificPopup({
            delegate: '.js-show-popin-gallery',
            type: 'image',
            tLoading: 'Loading image #%curr%...',
            mainClass: 'mfp-img-mobile',
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
            }
        });

        $('body').on('click', '.js-show-img', function(e) {
          var srcImage = $(e.currentTarget).find('.tooltip-pic').attr('data-src');
          var srcImageWidth = $(e.currentTarget).find('.tooltip-pic').attr('data-width');
          var srcImageHeight = $(e.currentTarget).find('.tooltip-pic').attr('data-height');
          var srcImageTitle = $(e.currentTarget).find('.tooltip-pic').attr('data-title');

          $.magnificPopup.open({
              mainClass: 'mfp-img-full mfp-fade',
              closeMarkup: '<button title="Close" type="button" class="mfp-close btn -no-border"><span class="icon-close"></span></button>',
              removalDelay: 500,
              items: {
                  type: 'inline',
                  src: '<div class="p-relative"><img class="of-cover original" style="background-color: white;" src=' + srcImage + ' width=' + srcImageWidth + ' height=' + srcImageHeight + ' title=' + srcImageTitle+' /></div>',
              },
          });
        })
    },

    onWindowLoad: function (e) {

    },

    onWindowScroll: function (e) {

    },
    onWindowResize: function (e) {

    }
});
